<form nz-form [formGroup]="validateForm">
  <div class="flex relative tab-vehicle">
    <div class="absolute z-10" style=" width: 160px; height: 160px; z-index: 1;">
      <nz-form-item>
        <nz-upload style="z-index: 2; text-align: center; margin-top: 20px;"
          class="avatar-uploader"
          nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          nzName="avatar"
          nzListType="picture-card"
          [nzShowUploadList]="false"
          [nzBeforeUpload]="beforeUpload"
          (nzChange)="handleChange($event)"
        >
        <ng-container *ngIf="!avatarUrl">
          <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
          <div class="ant-upload-text">Upload</div>
        </ng-container>
        <img *ngIf="avatarUrl" [src]="avatarUrl" style="width: 100%" />
        </nz-upload>
      </nz-form-item>
    </div>
    <div class="tab-vehicle"> 
      <nz-tabset [style.height.px]="heightTab"  [nzTabPosition]="'left'">
        <nz-tab *ngFor="let tab of tabs;let i = index" [nzForceRender]="true"
          [nzTitle]="tab.title">
          <app-tab-content-popup [tab]="tab"></app-tab-content-popup>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close($event)">Đóng</button>
    <button nz-button nzType="primary" (click)="add()">Thêm</button>
  </div>
</form>
